import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { MineralShowcase } from './components/MineralShowcase';
import { Certifications } from './components/Certifications';
import { GlobalOperations } from './components/GlobalOperations';
import { ContactSection } from './components/ContactSection';
function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Navigation data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutUs data-id="element-4" />
        <MineralShowcase data-id="element-5" />
        <Certifications data-id="element-6" />
        <GlobalOperations data-id="element-7" />
        <ContactSection data-id="element-8" />
      </main>

      <footer className="bg-gray-900 text-white py-12 border-t border-gray-800" data-id="element-9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-11">
            <div className="mb-6 md:mb-0" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/v9c2EAFGxnXmFVasKusPuE/............png" alt="Kale Cooperative Minerals SPRL" className="h-20 w-auto mb-3" data-id="element-13" />
              <p className="text-gray-400 mt-2 text-sm" data-id="element-14">
                Certified mining and mineral trading company from the RDC.
              </p>
            </div>

            <div className="flex space-x-8 text-sm text-gray-400" data-id="element-15">
              <a href="#" className="hover:text-white transition-colors" data-id="element-16">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-17">
                Terms of Service
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-18">
                Shipping Info
              </a>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-800 text-center text-sm text-gray-500" data-id="element-19">
            &copy; {new Date().getFullYear()} Kale Cooperative Minerals SPRL.
            All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}
export { App };